import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [!_vm.lazy ? _c("div", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_vm._v(" " + _vm._s(_vm.id ? "编辑" : "新增") + " "), _c("div", {
    staticClass: "d2-fr"
  }, [_vm.isHasPermission ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存 ")]) : _vm._e(), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: _vm.back
    }
  }, [_vm._v("返回")])], 1)]) : _vm._e(), _c("div", {
    staticClass: "task-content"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "120px",
      size: "mini"
    }
  }, [_c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "客户名称",
      prop: "c01CusName"
    }
  }, [_c("div", {
    staticClass: "cus-name-wrap"
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入正确的客户全称",
      maxlength: 50,
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.c01CusName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01CusName", $$v);
      },
      expression: "form.c01CusName"
    }
  })], 1)])], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "客户简称"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入正确的客户简称",
      maxlength: 10,
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.c01CusShortName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01CusShortName", $$v);
      },
      expression: "form.c01CusShortName"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "客户信息"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入客户的行业，出资类型，架构类型，是否公众公司等信息",
      maxlength: 500,
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.c01CusInfo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01CusInfo", $$v);
      },
      expression: "form.c01CusInfo"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "主办部门",
      prop: "c01StrucCode"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      placeholder: "请选择"
    },
    on: {
      change: _vm.getStrucMsg
    },
    model: {
      value: _vm.form.c01StrucCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01StrucCode", $$v);
      },
      expression: "form.c01StrucCode"
    }
  }, _vm._l(_vm.strucList, function (item) {
    return _c("el-option", {
      key: item.l01StrucCode,
      attrs: {
        label: "".concat(item.l01StrucCode, "-").concat(item.l01Name),
        value: item.l01StrucCode
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "报告期间",
      prop: "c01StartDate"
    }
  }, [_c("el-row", {
    attrs: {
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 11
    }
  }, [_c("el-date-picker", {
    staticClass: "select date-select-no-icon app-form-component-select",
    attrs: {
      clearable: false,
      "value-format": "yyyy-MM-dd",
      type: "date"
    },
    on: {
      change: _vm.updateReportName
    },
    model: {
      value: _vm.form.c01StartDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01StartDate", $$v);
      },
      expression: "form.c01StartDate"
    }
  })], 1), _c("el-col", {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      span: 2
    }
  }, [_vm._v(" 至 ")]), _c("el-col", {
    attrs: {
      span: 11
    }
  }, [_c("el-date-picker", {
    staticClass: "select date-select-no-icon app-form-component-select",
    attrs: {
      clearable: false,
      type: "date",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      change: _vm.updateReportName
    },
    model: {
      value: _vm.form.c01EndDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01EndDate", $$v);
      },
      expression: "form.c01EndDate"
    }
  })], 1)], 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item type",
    attrs: {
      label: "业务类型",
      prop: "c01N01Code"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      placeholder: "请选择"
    },
    on: {
      change: function change() {
        _vm.taskTypeChange();
      }
    },
    model: {
      value: _vm.form.c01N01Code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01N01Code", $$v);
      },
      expression: "form.c01N01Code"
    }
  }, _vm._l(_vm.strucCodes, function (item) {
    return _c("el-option", {
      key: item.n01Code,
      attrs: {
        label: "".concat(item.n01Code, "-").concat(item.n01Name, "(").concat(item.n01Risk, ")"),
        value: item.n01Code
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "风险/质控层级"
    }
  }, [_c("div", {
    staticClass: "el-input el-input--mini is-disabled"
  }, [_c("div", {
    staticClass: "el-input__inner"
  }, [_vm._v(_vm._s(_vm.form.c01RiskLevel) + " / " + _vm._s(_vm.form.c01QCLevel))])])])], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item struc-type",
    attrs: {
      label: "作业架构",
      prop: "c01StrucType"
    }
  }, [_c("div", {
    staticClass: "flex"
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !_vm.isHasPermission,
      placeholder: "请选择"
    },
    on: {
      change: _vm.updateReportName
    },
    model: {
      value: _vm.form.c01StrucType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01StrucType", $$v);
      },
      expression: "form.c01StrucType"
    }
  }, [_c("el-option", {
    attrs: {
      label: "单体",
      value: "单体"
    }
  }), _c("el-option", {
    attrs: {
      label: "合并",
      value: "合并"
    }
  })], 1), _vm.form.c01StrucType === "合并" ? _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      size: "mini",
      disabled: !_vm.isHasPermission,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.selectStrucType("children");
      }
    }
  }, [_vm._v("指定下级 ")]) : _vm._e()], 1)])], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "隶属母公司"
    }
  }, [_c("div", {
    staticClass: "flex"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      disabled: !_vm.isHasPermission
    },
    on: {
      click: function click($event) {
        return _vm.selectStrucType("parent");
      }
    }
  }, [_vm._v("指定上级 ")]), _vm.form.c01UpTaskId && _vm.upTaskName ? _c("el-tag", {
    staticClass: "select-tag cpsc-tag",
    attrs: {
      closable: !_vm.isHasPermission
    }
  }, [_c("span", {
    staticClass: "ellipsis",
    attrs: {
      title: _vm.upTaskName
    }
  }, [_vm._v(_vm._s(_vm.upTaskName))])]) : _vm._e()], 1)])], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "作业名称",
      prop: "c01TaskName"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: _vm.isLockTackName,
      placeholder: "",
      maxlength: 500,
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.c01TaskName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01TaskName", $$v);
      },
      expression: "form.c01TaskName"
    }
  }, [_c("el-button", {
    attrs: {
      slot: "append",
      size: "mini"
    },
    on: {
      click: function click($event) {
        _vm.isLockTackName = !_vm.isLockTackName;
      }
    },
    slot: "append"
  }, [_vm._v(" " + _vm._s(_vm.isLockTackName ? "编辑" : "锁定") + " ")])], 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "是否出具报告",
      prop: "c01ReportNeed"
    }
  }, [_c("cpsc-select", {
    attrs: {
      disabled: !_vm.isHasPermission,
      placeholder: "请选择是否出具报告"
    },
    model: {
      value: _vm.form.c01ReportNeed,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01ReportNeed", $$v);
      },
      expression: "form.c01ReportNeed"
    }
  }, [_c("el-option", {
    attrs: {
      label: "是",
      value: true
    }
  }), _c("el-option", {
    attrs: {
      label: "否",
      value: false
    }
  })], 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "预计报告日期",
      prop: "c01ReportDate"
    }
  }, [_c("el-date-picker", {
    staticClass: "select app-form-component-select",
    attrs: {
      type: "date",
      disabled: !_vm.isHasPermission,
      "value-format": "yyyy-MM-dd",
      placeholder: "选择日期"
    },
    model: {
      value: _vm.form.c01ReportDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01ReportDate", $$v);
      },
      expression: "form.c01ReportDate"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "函件主体事务所",
      prop: "c01OfficeName"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      "allow-create": "",
      clearable: "",
      "default-first-option": "",
      placeholder: "请选择函件主体事务所,可手动新增(输入事务所名称回车即可)"
    },
    model: {
      value: _vm.form.c01OfficeName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01OfficeName", $$v);
      },
      expression: "form.c01OfficeName"
    }
  }, _vm._l(_vm.officeName, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "映射作业",
      prop: "c01ReportMapping"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: true,
      maxlength: 500
    },
    model: {
      value: _vm.form.c01ReportMapping,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01ReportMapping", $$v);
      },
      expression: "form.c01ReportMapping"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "",
      label: "现场负责人"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var data = _ref.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              disabled: _vm.disabledOptions(item.id, "leaders") || item.vaild && (item.vaild === "false" || item.state !== 1),
              label: item.name,
              value: item.id
            }
          }, [_c("span", {
            staticStyle: {
              float: "left"
            }
          }, [_vm._v(_vm._s(item.name))]), _c("span", {
            staticStyle: {
              float: "right",
              color: "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(_vm.disabledOptions(item.id, "leaders") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
        });
      }
    }]),
    model: {
      value: _vm.form.leaders,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leaders", $$v);
      },
      expression: "form.leaders"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "managers",
      label: "主管经理"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      "collapse-tags": "",
      multiple: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.managers,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "managers", $$v);
      },
      expression: "form.managers"
    }
  }, _vm._l(_vm.managerList, function (item) {
    return _c("el-option", {
      key: item.n21Staff,
      attrs: {
        disabled: _vm.disabledOptions(item.n21Staff, "managers") || item.vaild && (item.vaild === "false" || item.state !== 1),
        label: item.n21StaffName,
        value: item.n21Staff
      }
    }, [_c("span", {
      staticStyle: {
        float: "left"
      }
    }, [_vm._v(_vm._s(item.n21StaffName))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.disabledOptions(item.n21Staff, "managers") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
  }), 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "partners",
      label: "主管合伙人"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      "collapse-tags": "",
      multiple: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.partners,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partners", $$v);
      },
      expression: "form.partners"
    }
  }, _vm._l(_vm.partnerList, function (item) {
    return _c("el-option", {
      key: item.n21Staff,
      attrs: {
        disabled: _vm.disabledOptions(item.n21Staff, "partners") || item.vaild && (item.vaild === "false" || item.state !== 1),
        label: item.n21StaffName,
        value: item.n21Staff
      }
    }, [_c("span", {
      staticStyle: {
        float: "left"
      }
    }, [_vm._v(_vm._s(item.n21StaffName))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.disabledOptions(item.n21Staff, "partners") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
  }), 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "四级质控人员"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      disabled: _vm.form.c01QCLevel != 4 && _vm.form.c01QCLevel != 5 || !!_vm.id && !_vm.isManagersOrPartners,
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.quality4,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "quality4", $$v);
      },
      expression: "form.quality4"
    }
  }, _vm._l(_vm.quality4List, function (item) {
    return _c("el-option", {
      key: item.n21Staff,
      attrs: {
        disabled: _vm.disabledOptions(item.n21Staff, "quality4") || item.vaild && (item.vaild === "false" || item.state !== 1),
        label: item.n21StaffName,
        value: item.n21Staff
      }
    }, [_c("span", {
      staticStyle: {
        float: "left"
      }
    }, [_vm._v(_vm._s(item.n21StaffName))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.disabledOptions(item.n21Staff, "partners") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
  }), 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "五级质控人员"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      disabled: _vm.form.c01QCLevel != 5 || !!_vm.id && !_vm.isManagersOrPartners,
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.quality5,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "quality5", $$v);
      },
      expression: "form.quality5"
    }
  }, _vm._l(_vm.quality5List, function (item) {
    return _c("el-option", {
      key: item.n21Staff,
      attrs: {
        disabled: _vm.disabledOptions(item.n21Staff, "quality5") || item.vaild && (item.vaild === "false" || item.state !== 1),
        label: item.n21StaffName,
        value: item.n21Staff
      }
    }, [_c("span", {
      staticStyle: {
        float: "left"
      }
    }, [_vm._v(_vm._s(item.n21StaffName))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.disabledOptions(item.n21Staff, "partners") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
  }), 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "授权查询人员"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      multiple: "",
      filterable: "",
      "show-tags": false,
      "collapse-tags": true,
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var data = _ref2.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              disabled: _vm.disabledOptions(item.id, "inquisitor") || item.vaild && (item.vaild === "false" || item.state !== 1),
              label: item.name,
              value: item.id
            }
          }, [_c("span", {
            staticStyle: {
              float: "left"
            }
          }, [_vm._v(_vm._s(item.name))]), _c("span", {
            staticStyle: {
              float: "right",
              color: "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(_vm.disabledOptions(item.n21Staff, "partners") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
        });
      }
    }]),
    model: {
      value: _vm.form.inquisitor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "inquisitor", $$v);
      },
      expression: "form.inquisitor"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "participants",
      label: "参与人员"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      multiple: "",
      filterable: "",
      "show-tags": false,
      "collapse-tags": true,
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      disabled: !_vm.isHasPermission,
      placeholder: "请选择"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var data = _ref3.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              disabled: _vm.disabledOptions(item.id, "participants") || item.vaild && (item.vaild === "false" || item.state !== 1),
              label: item.name,
              value: item.id
            }
          }, [_c("span", {
            staticStyle: {
              float: "left"
            }
          }, [_vm._v(_vm._s(item.name))]), _c("span", {
            staticStyle: {
              float: "right",
              color: "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(_vm.disabledOptions(item.id, "participants") ? "负责人、经理、合伙人、质控、查询、参与人员互斥" : item.vaild ? item.vaild === "false" ? "未绑定租户" : item.state !== 1 ? "被禁止使用" : "" : ""))])]);
        });
      }
    }]),
    model: {
      value: _vm.form.participants,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "participants", $$v);
      },
      expression: "form.participants"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row-flex",
    attrs: {
      gutter: 0,
      type: "flex"
    }
  }, [_c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item struc-type",
    attrs: {
      label: "处理回函",
      prop: "c01IsPublic"
    }
  }, [_c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "项目组+函证中心共同处理回函",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_vm._v("处理回函"), _c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)]), _c("div", {
    staticClass: "flex"
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.c01IsPublic,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01IsPublic", $$v);
      },
      expression: "form.c01IsPublic"
    }
  }, [_c("el-option", {
    attrs: {
      label: "是",
      value: true
    }
  }, [_c("span", {
    staticStyle: {
      float: "left"
    }
  }, [_vm._v("是")]), _c("span", {
    staticStyle: {
      float: "right",
      color: "#8492a6",
      "font-size": "13px",
      "margin-left": "5px"
    }
  }, [_vm._v("可由项目组处理邮寄回函")])]), _c("el-option", {
    attrs: {
      label: "否",
      value: false
    }
  }, [_c("span", {
    staticStyle: {
      float: "left"
    }
  }, [_vm._v("否")]), _c("span", {
    staticStyle: {
      float: "right",
      color: "#8492a6",
      "font-size": "13px",
      "margin-left": "5px"
    }
  }, [_vm._v("只能由函证中心处理邮寄回函")])])], 1)], 1)], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "创建人员/日期"
    }
  }, [_c("div", {
    staticClass: "el-input el-input--mini is-disabled"
  }, [_c("div", {
    staticClass: "el-input__inner"
  }, [_vm._v(_vm._s(_vm.form.c01CreateStaffName) + " / " + _vm._s(_vm._f("date")(_vm.form.c01CreateDate, "yyyy-MM-dd")) + " ")])])])], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "函证领取状态"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.c01FileState,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01FileState", $$v);
      },
      expression: "form.c01FileState"
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "row-col",
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "作业状态"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.c01TaskState,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c01TaskState", $$v);
      },
      expression: "form.c01TaskState"
    }
  })], 1)], 1)], 1)], 1), _vm.id ? _c("div", {
    staticClass: "data-table"
  }, [_c("div", {
    staticClass: "app-page-header data-table-title"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(" 被审单位函证科目期末余额 "), _c("el-input", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      placeholder: "请输入科目名称",
      size: "mini"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return function () {
          return _vm.handleCurrentChange(1);
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchKey,
      callback: function callback($$v) {
        _vm.searchKey = $$v;
      },
      expression: "searchKey"
    }
  })], 1), _vm.isStaffPermission ? _c("div", {
    staticClass: "right"
  }, [_vm.isHasPermission && !_vm.lazy ? _c("el-dropdown", {
    staticClass: "app-inline-btn",
    attrs: {
      size: "mini"
    },
    on: {
      command: _vm.handleTableBatch
    }
  }, [_c("span", {
    staticClass: "link"
  }, [_vm._v(" 批量"), _c("i", {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-dropdown-item", {
    attrs: {
      disabled: _vm.selectedList.length === 0,
      command: "del"
    }
  }, [_vm._v("删除")])], 1)], 1) : _vm._e(), !_vm.lazy ? _c("el-button", {
    staticClass: "app-inline-btn",
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.createItem("new");
      }
    }
  }, [_vm._v("新增")]) : _vm._e()], 1) : _vm._e()]), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.accountListLoading,
      expression: "accountListLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "mini",
      data: _vm.tableData,
      border: "",
      stripe: ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      width: "55"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "c12AccountName",
      label: "科目名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "c12Time",
      label: "截止日期",
      sortable: "custom",
      width: "95"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c12Time, "yyyy-MM-dd")) + " ")];
      }
    }], null, false, 1277455817)
  }), _c("el-table-column", {
    attrs: {
      label: "日期类型",
      prop: "c12TimeType",
      width: "70"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "科目余额",
      sortable: "custom",
      width: "125",
      prop: "c12AccountSum",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.toThousandsForMates(scope.row.c12AccountSum)) + " ")];
      }
    }], null, false, 151176405)
  }), _c("el-table-column", {
    attrs: {
      label: "科目发函合计",
      prop: "c12ConfirmSendSum",
      width: "125",
      sortable: "custom",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.toThousandsForMates(scope.row.c12ConfirmSendSum)) + " ")];
      }
    }], null, false, 765382042)
  }), _c("el-table-column", {
    attrs: {
      label: "发函比例",
      prop: "c12ConfirmSendRatio",
      width: "95",
      sortable: "custom",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.toPercentage(scope.row.c12ConfirmSendRatio)) + " ")];
      }
    }], null, false, 938260784)
  }), _c("el-table-column", {
    attrs: {
      label: "科目回函合计",
      width: "125",
      prop: "c12ConfirmBackSum",
      sortable: "custom",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.toThousandsForMates(scope.row.c12ConfirmBackSum)) + " ")];
      }
    }], null, false, 569719661)
  }), _c("el-table-column", {
    attrs: {
      label: "回函比例",
      width: "95",
      sortable: "custom",
      prop: "c12ConfirmBackRatio",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.toPercentage(scope.row.c12ConfirmBackRatio)) + " ")];
      }
    }], null, false, 4036586855)
  }), _c("el-table-column", {
    attrs: {
      label: "最后编辑人姓名",
      prop: "c12StaffName",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "编辑日期",
      width: "95",
      sortable: "custom",
      prop: "c12EditDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c12EditDate, "yyyy-MM-dd")) + " ")];
      }
    }], null, false, 4133057972)
  }), _vm.isStaffPermission && !_vm.lazy ? _c("el-table-column", {
    attrs: {
      label: "操作",
      prop: "address",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.c12EditStaff === _vm.userId ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            icon: "el-icon-edit",
            title: "编辑"
          },
          on: {
            click: function click($event) {
              return _vm.createItem("edit", scope.row.c12Id);
            }
          }
        }) : _vm._e(), _vm.isHasPermission ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            title: "删除",
            icon: "el-icon-delete"
          },
          on: {
            click: function click($event) {
              return _vm.delAccount(scope.row.c12Id);
            }
          }
        }) : _vm._e()];
      }
    }], null, false, 2321655023)
  }) : _vm._e()], 1), _c("cpsc-auto-pagination", {
    attrs: {
      "current-page": _vm.currentPage,
      total: _vm.totalPages
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      }
    }
  })], 1) : _vm._e()], 1), _vm.template ? _c(_vm.template, {
    tag: "component"
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };